<ada-card
	#RiskPropertiesCard
	id="RiskPropertiesCard"
	width="100%"
	[collapseEnabled]="true"
	[verticalSpacing]="'Small'"
>
	<ada-text
		content="Risk Properties"
		data-container-selector="ada-card-header"
		id="RiskPropertiesCardHeader"
	/>
	<ada-container
		data-container-selector="ada-card-body"
		horizontalSpacing="Medium"
		verticalSpacing="Medium"
		[colCount]="4"
		[padding]="defaultCardPadding"
	>
		<ng-container *ngIf="'Criticality' | displayAuthoringProperty: editorClass : propertyConstructor.namespace">
			<ada-authoring-property-label
				#CriticalityLabel
				id="CriticalityLabel"
				[content]="'Criticality'"
				[isDisabled]="isDisabled"
				[isRequired]="'Criticality' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-container
				[colCount]="2"
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					#CriticalityInput
					id="CriticalityInput"
					[debounce]="100"
					[isDisabled]="isDisabled"
					[max]="100"
					[min]="0"
					[outputDateAsInteger]="true"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[showAsFullWidth]="true"
					[type]="'number'"
					[value]="currentPropertyObject?.Criticality"
					(valueChange)="setObjectPropertyValue('Criticality', +$event)"
				/>
			</ada-container>
		</ng-container>
		<ng-container *ngIf="'CveIds' | displayAuthoringProperty: editorClass : propertyConstructor.namespace">
			<ada-authoring-property-label
				#CveIdsLabel
				id="CveIdsLabel"
				[content]="'CVE IDs'"
				[inheriting]="currentPropertyObject?.CveIds | inheritPipe: inheritedPropertyObject?.CveIds"
				[isDisabled]="isDisabled"
				[isRequired]="'CveIds' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('CveIds')"
			/>
			<ada-container
				[colCount]="2"
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-list-builder
					id="CveIdsInput"
					[addButtonText]="'Add CVE ID'"
					[isDisabled]="isDisabled"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[value]="currentPropertyObject?.CveIds"
					(valueChange)="setCveIds($event)"
				/>
			</ada-container>
		</ng-container>
		<ng-container *ngIf="'CvssScores' | displayAuthoringProperty: editorClass : propertyConstructor.namespace">
			<ada-authoring-property-label
				#CvssScoresLabel
				id="CvssScoresLabel"
				[content]="'Cvss Scores'"
				[inheriting]="currentPropertyObject?.CvssScores | inheritPipe: inheritedPropertyObject?.CvssScores"
				[isDisabled]="isDisabled"
				[isRequired]="'CvssScores' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('CvssScores')"
			/>
			<ada-container
				[colCount]="2"
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-list-builder
					id="CvssScoresInput"
					[addButtonText]="'Add CVSS Score'"
					[isDisabled]="isDisabled"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[type]="'number'"
					[value]="currentPropertyObject?.CvssScores"
					(valueChange)="setCvssScores($event)"
				/>
			</ada-container>
		</ng-container>
		<ng-container *ngIf="'CveIds' | displayAuthoringProperty: editorClass : propertyConstructor.namespace">
			<ada-authoring-property-label
				#SecurityExposureLevelLabel
				id="SecurityExposureLevelLabel"
				[content]="'Security Exposure Level'"
				[inheriting]="currentPropertyObject?.CveIds | inheritPipe: inheritedPropertyObject?.CveIds"
				[isDisabled]="isDisabled"
				[isRequired]="'CveIds' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('CveIds')"
			/>
			<ada-container
				[colCount]="2"
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-combo
					#SecurityExposureLevelInput
					id="SecurityExposureLevelInput"
					[isDisabled]="isDisabled"
					[options]="securityExposureLevelOptions"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[value]="currentPropertyObject?.SecurityExposureLevel"
					(valueChange)="setObjectPropertyValue('SecurityExposureLevel', $event)"
				/>
			</ada-container>
		</ng-container>
		<ng-container *ngIf="'KnownExploitExists' | displayAuthoringProperty: editorClass : propertyConstructor.namespace">
			<ada-authoring-property-label
				#KnownExploitExistsLabel
				id="KnownExploitExistsLabel"
				[content]="'Known Exploit Exists'"
				[inheriting]="currentPropertyObject?.KnownExploitExists | inheritPipe: inheritedPropertyObject?.KnownExploitExists"
				[isDisabled]="isDisabled"
				[isRequired]="'KnownExploitExists' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('KnownExploitExists')"
			/>
			<ada-container
				[colCount]="2"
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-toggle-switch
					#KnownExploitExistsInput
					id="KnownExploitExistsInput"
					[isDisabled]="isDisabled"
					[isToggled]="currentPropertyObject?.KnownExploitExists"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					(isToggledChange)="setObjectPropertyValue('KnownExploitExists', $event)"
				/>
			</ada-container>
		</ng-container>
	</ada-container>
</ada-card>
